// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"fa3be1e9","693":"b7606990"}[chunkId] + ".chunk.js";
};